// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Combos_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /so/combos/remover.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Combos_RemoverResponseDados {
so_combo_id: number
}

export type Combos_RemoverResponse = ApiResponse<Combos_RemoverResponseDados>;

registerResponseContract('Combos_RemoverResponse', {
  so_combo_id: { type: 'number',  required: true },
})
